import React from 'react'
import classNames from 'classnames'
import {
  animationDuration,
  positiveIconTrackName,
  negativeIconTrackName,
  negativeFeedbackResponse,
  positiveFeedbackResponse,
  questionText,
  afterFeedbackText,
  afterWrittenFeedbackText,
  writtenFeedbackTrackName,
  writtenFeedbackPlaceholder,
  buttonText,
  buttonTrackName
} from '../../../../config/feedbackSection'

class FeedbackSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showAnimation: null,
      feedback: null,
      extraFeedbackGiven: false
    }

    this.setFeedback = this.setFeedback.bind(this)
    this.sendExtraFeedback = this.sendExtraFeedback.bind(this)
  }

  setFeedback (e) {
    const feedback = e.target.getAttribute('data-feedback')
    if (!this.state.feedback) this.setState({ showAnimation: feedback })
    setTimeout(() => { this.setState({ feedback, showAnimation: null }) }, animationDuration)
  }

  sendExtraFeedback (e) {
    this.setState({ extraFeedbackGiven: true })
  }

  render () {
    return (
      <div className='container feedback'>
        <FeedbackHeading {...this.state} />
        <span className='inline-table'>
          <ThumbAndMessage iconType='positive' setFeedback={this.setFeedback} {...this.state} />
          <ThumbAndMessage iconType='negative' setFeedback={this.setFeedback} {...this.state} />
        </span>
        <ExtraFeedbackEntry sendExtraFeedback={this.sendExtraFeedback} {...this.state} />
      </div>
    )
  }
}

export default FeedbackSection

export const ThumbAndMessage = ({ iconType, feedback, setFeedback, showAnimation, extraFeedbackGiven }) => {
  if (extraFeedbackGiven || (feedback && feedback !== iconType)) return null

  const iconClass = classNames('fa', 'feedback-icon', {
    'mr-4': !feedback,
    'feedback-given': feedback,
    'animate-thumbup': iconType === 'positive' && showAnimation === 'positive',
    'animate-thumbdown': iconType === 'negative' && showAnimation === 'negative',
    'fa-thumbs-o-up': iconType === 'positive',
    'fa-thumbs-o-down': iconType === 'negative',
    'negative': feedback === 'negative'
  })
  const feedbackClass = classNames('feedback-response', {
    'negative': feedback === 'negative'
  })

  const responseText = feedback === 'positive' ? positiveFeedbackResponse : negativeFeedbackResponse

  const trackName = iconType === 'positive' ? positiveIconTrackName : negativeIconTrackName

  return [
    <i name={trackName} key='0' style={{ animationDuration: animationDuration + 'ms' }} onClick={setFeedback} data-feedback={iconType} className={iconClass} aria-hidden='true' />,
    feedback === iconType && <span key='1' className={feedbackClass}>{responseText}</span>
  ]
}

export const FeedbackHeading = ({ feedback, extraFeedbackGiven }) => {
  let text = extraFeedbackGiven ? afterWrittenFeedbackText : afterFeedbackText
  if (!feedback) text = questionText
  return <div className='feedback-title'>{text}</div>
}

export const ExtraFeedbackEntry = ({ feedback, extraFeedbackGiven, sendExtraFeedback }) => {
  if (feedback !== 'negative' || extraFeedbackGiven) return null
  return (
    <div className='feedback-area'>
      <textarea data-public='true' name={writtenFeedbackTrackName} autoFocus rows='3' className='text-muted' placeholder={writtenFeedbackPlaceholder} />
      <a name={buttonTrackName} onClick={sendExtraFeedback} className='btn btn-primary pull-right'>{buttonText}</a>
    </div>
  )
}



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/components/feedbackSection.jsx